(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-preorder-delivery"] && !Shopify.designMode) return;
  try {
    

(() => {

  async function localizeProductNames(root) {

    const market =
      root.dataset.market ||
      'JP';


    /*
     * GASがShopify Marketsから取得して
     * data-marketsに埋め込んだ値を使用
     *
     * 例:
     * data-markets="JP,TW,HK,US"
     *
     * US販売不可:
     * data-markets="JP,TW,HK"
     *
     * 海外販売不可:
     * data-markets="JP"
     */

    let cards =
      Array.from(
        root.querySelectorAll(
          '[data-htd-card]'
        )
      );


    /*
     * 現在のマーケットで販売されていない商品を
     * 最初にDOMから除外
     */

    cards.forEach(
      card => {

        const markets =
          (
            card.dataset.markets ||
            ''
          )
            .split(',')
            .map(
              value =>
                value.trim()
            )
            .filter(Boolean);


        /*
         * data-markets属性がある
         * 新GAS出力だけ判定
         *
         * 属性が空の場合は
         * どの対象マーケットでも販売不可なので削除
         */

        if (
          card.hasAttribute(
            'data-markets'
          ) &&
          !markets.includes(
            market
          )
        ) {
          card.remove();
        }
      }
    );


    /*
     * 削除後にカードを再取得
     */

    cards =
      Array.from(
        root.querySelectorAll(
          '[data-htd-card]'
        )
      );


    if (
      !cards.length
    ) {
      return;
    }


    /*
     * 現在の言語を含むShopify root
     *
     * 日本語: /
     * 英語: /en/
     * 繁体字: /zh/
     */

    const rootPath =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';


    const titleCache =
      new Map();


    /*
     * Shopifyの商品翻訳タイトルを取得
     */

    async function getLocalizedTitle(
      handle
    ) {

      if (
        titleCache.has(
          handle
        )
      ) {
        return titleCache.get(
          handle
        );
      }


      try {

        const endpoint =
          rootPath +
          'products/' +
          encodeURIComponent(
            handle
          ) +
          '.js';


        const response =
          await fetch(
            endpoint,
            {
              headers: {
                Accept:
                  'application/json'
              },

              credentials:
                'same-origin',

              cache:
                'no-store'
            }
          );


        if (
          !response.ok
        ) {
          return null;
        }


        const product =
          await response.json();


        if (
          !product ||
          !product.title
        ) {
          return null;
        }


        const title =
          product.title.trim();


        titleCache.set(
          handle,
          title
        );


        return title;


      } catch (error) {

        console.warn(
          'Product localization failed:',
          error
        );

        return null;
      }
    }


    /*
     * 残った商品だけ
     * 現地言語の商品名へ変更
     */

    await Promise.all(

      cards.map(
        async card => {

          const productLink =
            card.querySelector(
              'a[href*="/products/"]'
            );


          /*
           * GASが埋め込んだhandleを優先
           */

          let handle =
            (
              card.dataset
                .productHandle ||
              ''
            ).trim();


          /*
           * 旧HTMLとの互換用
           */

          if (
            !handle &&
            productLink
          ) {
            try {

              const url =
                new URL(
                  productLink.href,
                  window.location.origin
                );


              const match =
                url.pathname.match(
                  /\/products\/([^/?#]+)/
                );


              if (match) {
                handle =
                  decodeURIComponent(
                    match[1]
                  );
              }

            } catch (error) {
              return;
            }
          }


          if (!handle) {
            return;
          }


          /*
           * 商品リンクも現在の言語に合わせる
           *
           * variantなど元URLのqueryは維持
           */

          if (productLink) {

            try {

              const originalUrl =
                new URL(
                  productLink.href,
                  window.location.origin
                );


              productLink.href =
                rootPath +
                'products/' +
                encodeURIComponent(
                  handle
                ) +
                originalUrl.search +
                originalUrl.hash;


            } catch (error) {
              /*
               * リンク書き換えに失敗しても
               * 商品表示自体は継続
               */
            }
          }


          /*
           * 日本マーケットでは
           * GAS側の商品名をそのまま使う
           */

          if (
            market === 'JP'
          ) {
            return;
          }


          const localizedTitle =
            await getLocalizedTitle(
              handle
            );


          /*
           * 取得できなかった場合は
           * 元の商品名を維持
           */

          if (
            !localizedTitle
          ) {
            return;
          }


          const heading =
            card.querySelector(
              'h3, h2'
            );


          if (heading) {

            const headingLink =
              heading.querySelector(
                'a'
              );


            if (headingLink) {
              headingLink.textContent =
                localizedTitle;
            } else {
              heading.textContent =
                localizedTitle;
            }
          }


          /*
           * プルダウンの商品名にも反映
           */

          const currentSearch =
            (
              card.dataset.search ||
              ''
            ).trim();


          const skuMatch =
            currentSearch.match(
              /(?:^|\s)([A-Z0-9]+-[A-Z0-9-]+)$/
            );


          if (skuMatch) {

            card.dataset.search =
              localizedTitle +
              ' ' +
              skuMatch[1];

          } else {

            card.dataset.search =
              localizedTitle;
          }
        }
      )
    );
  }


  async function init(root) {

    if (
      root.dataset
        .htdSelectorReady ||
      root.dataset
        .htdSelectorLoading
    ) {
      return;
    }


    root.dataset
      .htdSelectorLoading =
      'true';


    /*
     * 先に
     *
     * 1. Markets除外
     * 2. 商品名翻訳
     *
     * を終わらせる
     */

    await localizeProductNames(
      root
    );


    /*
     * Markets除外後のカードだけ取得
     */

    const cards =
      Array.from(
        root.querySelectorAll(
          '[data-htd-card]'
        )
      );


    const tools =
      root.querySelector(
        '[data-htd-tools]'
      );


    const select =
      root.querySelector(
        '[data-htd-select]'
      );


    const count =
      root.querySelector(
        '[data-htd-count]'
      );


    const empty =
      root.querySelector(
        '[data-htd-no-results]'
      );


    if (
      !tools ||
      !select ||
      !count
    ) {
      delete root.dataset
        .htdSelectorLoading;

      return;
    }


    /*
     * このマーケットに表示できる予約商品が
     * 1つもない場合
     */

    if (
      !cards.length
    ) {

      if (empty) {
        empty.hidden =
          false;
      }


      tools.hidden =
        true;


      root.dataset
        .htdSelectorReady =
        'true';


      delete root.dataset
        .htdSelectorLoading;


      return;
    }


    /*
     * Theme editor等で再読み込みされた場合の
     * 重複防止
     */

    Array.from(
      select.querySelectorAll(
        'optgroup'
      )
    )
      .forEach(
        option =>
          option.remove()
      );


    /*
     * SKU先頭文字でカテゴリー分類
     */

    const groups =
      new Map([
        [
          'B',
          {
            label:
              select.dataset
                .categoryBags,

            items: []
          }
        ],

        [
          'W',
          {
            label:
              select.dataset
                .categoryWallets,

            items: []
          }
        ],

        [
          'A',
          {
            label:
              select.dataset
                .categoryAccessories,

            items: []
          }
        ],

        [
          'other',
          {
            label:
              select.dataset
                .categoryOther,

            items: []
          }
        ]
      ]);


    const names =
      new Map();


    const products =
      cards.map(
        (
          card,
          index
        ) => {

          const search =
            (
              card.dataset.search ||
              ''
            ).trim();


          const sku =
            (
              search.match(
                /(?:^|\s)([A-Z0-9]+-[A-Z0-9-]+)$/
              ) || []
            )[1] ||
            '';


          const heading =
            card.querySelector(
              'h3, h2'
            );


          const headingName =
            heading
              ? (
                  heading.innerText ||
                  heading.textContent ||
                  ''
                )
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim()
              : '';


          const fallbackName =
            sku
              ? search
                  .slice(
                    0,
                    -sku.length
                  )
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim()
              : search
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim();


          const name =
            headingName ||
            fallbackName ||
            sku ||
            String(
              index + 1
            );


          names.set(
            name,
            (
              names.get(name) ||
              0
            ) + 1
          );


          return {
            name,
            sku,
            index
          };
        }
      );


    /*
     * カテゴリーに格納
     */

    products.forEach(
      product => {

        /*
         * 旧SKU（B-ZMT-BL 等）は先頭ブロックの1文字目、
         * 統一品番（HT-NBK-H005-01 等）は3ブロック目の1文字目で分類する
         *   H/S/B = バッグ（ハンド/ショルダー/バックパック）
         *   W     = 財布
         *   A/P   = 小物・アクセサリー（アクセサリー/ポーチ）
         *   それ以外 = その他
         */
        const skuParts =
          product.sku
            .split('-');

        let prefix =
          skuParts[0];

        if (
          skuParts[0] === 'HT' &&
          skuParts.length >= 4
        ) {
          const categoryLetter =
            (skuParts[2] || '').charAt(0);

          const newSkuGroups = {
            H: 'B', S: 'B', B: 'B',
            W: 'W',
            A: 'A', P: 'A'
          };

          prefix =
            newSkuGroups[categoryLetter] ||
            'other';
        }


        const group =
          groups.get(
            prefix
          ) ||
          groups.get(
            'other'
          );


        group.items.push(
          product
        );
      }
    );


    /*
     * select生成
     */

    groups.forEach(
      group => {

        if (
          !group.items.length
        ) {
          return;
        }


        const optgroup =
          document
            .createElement(
              'optgroup'
            );


        optgroup.label =
          group.label;


        group.items.forEach(
          product => {

            const option =
              document
                .createElement(
                  'option'
                );


            option.value =
              String(
                product.index
              );


            option.textContent =
              product.name +
              (
                names.get(
                  product.name
                ) > 1 &&
                product.sku

                  ? (
                      '（' +
                      product.sku +
                      '）'
                    )

                  : ''
              );


            optgroup
              .appendChild(
                option
              );
          }
        );


        select
          .appendChild(
            optgroup
          );
      }
    );


    /*
     * 商品選択時の表示切り替え
     */

    const update =
      () => {

        let visible =
          0;


        cards.forEach(
          (
            card,
            index
          ) => {

            const match =
              select.value ===
                '' ||
              select.value ===
                String(index);


            card.hidden =
              !match;


            if (match) {
              visible += 1;
            }
          }
        );


        count.textContent =
          visible +
          ' / ' +
          cards.length;


        if (empty) {
          empty.hidden =
            visible !== 0;
        }
      };


    select.addEventListener(
      'change',
      update
    );


    root.dataset
      .htdSelectorReady =
      'true';


    delete root.dataset
      .htdSelectorLoading;


    tools.hidden =
      false;


    update();
  }


  function boot(scope) {

    if (
      scope.matches &&
      scope.matches(
        '[data-htd-page]'
      )
    ) {
      init(scope);
    }


    scope
      .querySelectorAll(
        '[data-htd-page]'
      )
      .forEach(
        init
      );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () =>
        boot(document)
    );

  } else {

    boot(document);
  }


  document.addEventListener(
    'shopify:section:load',
    event =>
      boot(
        event.target
      )
  );

})();


  } catch(e) { console.error(e); }
})();
})();
